module.exports = __webpack_public_path__ + "static/media/Law.f628bd69.png";